class {
    onCreate(input) {
        this.state = {
            isLoggedIn: input.isLoggedIn,
            username: input.username,
            menuPanelClass: "menu-panel-close"
        }
    }

    clickMenu(event) {
        this.state.menuPanelClass = "menu-panel";
        document.getElementById("menu-panel").className = "menu-panel";
    }

    escapeMenu(event) {
        this.closeMenu();
    }

    closeMenu() {
        this.state.menuPanelClass = "menu-panel-close";
    }
}
<div.menu>
   
    <ebay-icon-button#menu-button
        on-click('clickMenu')
        on-escape('escapeMenu')
    >
        <ebay-menu-icon/>
    </ebay-icon-button>
    <div class=state.menuPanelClass  id="menu-panel">
        <div.profile-icon>
            <ebay-profile-icon />
        </div>
        <div.username>
            ${state.username}
        </div>
        <span.menu-list>
            <ul>
                <li><a href="/">首页</a></li>
                <if(state.isLoggedIn)>
                    <hr>
                    <li><a href="/profile">配置</a></li>
                    <li><a target="_blank" id="clipboard" href="/clipboard">剪貼板</a></li>
                </if>
                <li><a target="_blank" id="json-tool" href="/json">JSON工具</a></li>
                <li><a target="_blank" id="color-tool" href="/color">颜色工具</a></li>
                <!-- <li><a href="#">关于</a></li> -->
                <hr>
                <if(state.isLoggedIn)>
                    <li><a href="/logout">登出</a></li>
                </if>
                <else>
                    <li><a href="/login">登入/注册</a></li>
                 </else>
                 <hr id="last">
                 <li><a id="eastday" target="_blank"  href="https://wap.eastday.com/">东方新闻</a></li>
            </ul>
        </span>
    </div>
</div>